module.exports = __webpack_public_path__ + "img/catch_moter.dce47eaa.svg";